<template>
<div>
    <data-view v-on:delete-data="deleteData" v-on:update-data="updateData" v-for="data in dataList" :data="data" v-bind:key="data.key" class="column is-half box" v-bind:class="isActive(data.status)"></data-view>
</div>
</template>

<style scoped>
.box{
    border: 1px solid #ccc;
    width: 49% !important;
    margin: 4px;
    padding: 0px !important;
}
.active{
    border: 1px solid rgb(6, 50, 247);
}
</style>
<script>
import DataView from '../Notifications/DataView';
import axios from 'axios'
import { ToastProgrammatic as Toast } from 'buefy'

export default {
    data() {
        return {
            input: {
            },
            data : {
                repeatOn : []
            },
            result: "",
        };
    },
    props: ['dataList'],
    components: {
        DataView,
    },
    methods: {
        isActive(myStatus){
            if (myStatus == 1){
                return "active"
            }else{
                return ""
            }
        },

        // imin bawah ni semua patut guna new endpoint laaa
        deleteData(data) {
            let self = this;
            this.$swal({
                title: "Are you sure?",
                text: "zzzThis notification (" + data.title + ") will be permanently removed.",
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: true
            }).then((result) => {
                console.log("imini result")
                console.log(result)
                if (result.value){

                    this.input.email = localStorage.getItem('email')
                    this.input.notificationID = data._id

                    const dataIndex = this.dataList.indexOf(data);
                    this.dataList.splice(dataIndex, 1);

                    axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
                    axios.defaults.responseType = 'json'
                    axios.post(process.env.NEW_ENDPOINT + '/api/notifications/remove', this.input)
                        .then(response => {

                            if (response.data.success == false) {
                                Toast.open({
                                    message: response.data.msg,
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            } else {
                                Toast.open({
                                    message: response.data.msg,
                                    type: 'is-success',
                                    duration: 3000
                                })
                            }
                        })
                        .catch(e => {
                            console.log(e.response)
                            if (e.response.status === 401) {
                                console.log("salah login")
                                Toast.open({
                                    message: "Unauthorized access. Please re-login.",
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 10000
                                })
                            } else {
                                Toast.open({
                                    message: e,
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 10000
                                })
                            }
                        })
                }
            })
        },

        updateData(data) {
            if (data.title.length > 0 && data.message.length > 0 && data.repeatOn.length > 0 && data.repeatTime.length > 0){
                this.input.email = localStorage.getItem('email')
                this.input._id = data._id
                this.input.title = data.title
                this.input.message = data.message
                this.input.repeatOn = data.repeatOn
                this.input.repeatTime = data.repeatTime
                this.input.status = data.status
                this.input.target = 1   //1 is for teacher app

                console.log("updateData")
                console.log(this.input)
                axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
                axios.defaults.responseType = 'json'
                axios.post(process.env.MY_URL + '/api/notifications/update', this.input)
                    .then(response => {
                        if (response.data.success == false) {
                            Toast.open({
                                message: response.data.msg,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        } else {
                            Toast.open({
                                message: response.data.msg,
                                type: 'is-success',
                                duration: 3000
                            })
                        }
                    })
                    .catch(e => {
                        console.log(e.response)
                        if (e.response.status === 401) {
                            console.log("salah login")
                            Toast.open({
                                message: "Unauthorized access. Please login again.",
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        } else {
                            Toast.open({
                                message: e,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        }
                    })

            } else {
                Toast.open({
                    message: "Please enter the values for all the fields.",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }
        },
    },
};
</script>

<style scoped>
p.tasks {
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Notifications/DataList.vue